import { Component } from '@angular/core';
import { PromptBlock } from '../prompt-block/prompt-block';
import { defaultPrompts } from '@eda/features/messenger/messenger.config';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'aiops-chat-welcome',
  imports: [PromptBlock, TranslatePipe],
  templateUrl: './chat-welcome.html'
})
export class ChatWelcome {
  defaultPrompts = defaultPrompts;
}
